import { render, staticRenderFns } from "./AppSnackBars.vue?vue&type=template&id=a5d3b308&scoped=true"
import script from "./AppSnackBars.vue?vue&type=script&lang=ts"
export * from "./AppSnackBars.vue?vue&type=script&lang=ts"
import style0 from "./AppSnackBars.vue?vue&type=style&index=0&id=a5d3b308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d3b308",
  null
  
)

export default component.exports